"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repeatInstructionsMessage = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const __1 = require("../../..");
const helpers_1 = require("../helpers");
const taskStore_1 = require("../../../taskStore");
const replayButtonHtmlId = 'replay-btn-revisited';
exports.repeatInstructionsMessage = {
    type: plugin_html_multi_response_1.default,
    data: () => {
        return {
            assessment_stage: 'instructions',
        };
    },
    stimulus: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<div class="lev-stimulus-container">
                ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                <div class="lev-row-container instruction">
                  <p>${t.generalRepeatInstructions}</p>
                </div>
              </div>`;
    },
    prompt_above_buttons: true,
    button_choices: ['Continue'],
    button_html: () => {
        const t = (0, taskStore_1.taskStore)().translations;
        return `<button class="primary">${t.continueButtonText}</button>`;
    },
    keyboard_choices: 'NO_KEYS',
    on_load: () => {
        helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.generalRepeatInstructions);
        const pageStateHandler = new helpers_1.PageStateHandler('generalRepeatInstructions', true);
        (0, helpers_1.setupReplayAudio)(pageStateHandler);
        (0, helpers_1.addExperimenterButtons)();
        (0, helpers_1.setupFullscreenButton)();
    },
    on_finish: () => {
        helpers_1.PageAudioHandler.stopAndDisconnectNode();
    },
};
